var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayBillOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 22,
    fill: "#575757"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dine In Mid Fid UI"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_141)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -286,
    y: -791,
    width: 390,
    height: 844,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 427318263"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -34,
    y: -33,
    width: 114,
    height: 45,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -33,
    y: -32,
    width: 112,
    height: 43,
    rx: 7,
    stroke: "#DFDFE2",
    strokeOpacity: 0.7,
    strokeWidth: 2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004086",
    filter: "url(#filter0_d_264_141)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 70,
    transform: "translate(-286 -16)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 54,
    transform: "translate(-26 -16)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4004",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 21L2.75 19.2609L4.5 21L6.25 19.2609L8 21L9.75 19.2609L11.5 21L13.25 19.2609L15 21V1L13.25 2.73913L11.5 1L9.75 2.73913L8 1L6.25 2.73913L4.5 1L2.75 2.73913L1 1V21V21Z",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4005",
    d: "M3.62402 6.21777H8.87402",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4006",
    d: "M3.62402 8.82617H7.12402",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4007",
    d: "M3.62402 11.4346H7.99902",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4008",
    d: "M3.62402 14.043H6.24902",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4009",
    d: "M11.5005 6.21777H12.3755",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4010",
    d: "M11.5005 8.82617H12.3755",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4011",
    d: "M11.5005 11.4346H12.3755",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4012",
    d: "M11.5005 14.043H12.3755",
    stroke: "#273135",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_264_141",
    x: -317,
    y: -44,
    width: 444,
    height: 124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_264_141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_264_141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_141"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -286,
    y: -791,
    width: 390,
    height: 844,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayBillOutlined);
export default __webpack_public_path__ + "static/media/payBill-outlined.f43486e4b94a591d379ed55755c4ea10.svg";
export { ForwardRef as ReactComponent };